// ThreeQuestionsB — stacked rows layout used on Home page

export default function ThreeQuestionsB() {
  return (
    <section className="tqb">
      <style>{`
        .tqb {
          width: 100%;
          background: var(--paper);
          padding: 40px 0;
          font-family: "Heebo", sans-serif;
          color: var(--ink);
          direction: rtl;
          box-sizing: border-box;
        }
        .tqb-head {
          display: grid;
          grid-template-columns: 1.4fr 1fr;
          gap: 32px;
          align-items: end;
          margin-bottom: 24px;
          padding-bottom: 18px;
          border-bottom: 2.5px solid var(--ink);
        }
        .tqb-eyebrow {
          font-family: "Space Grotesk", sans-serif;
          font-size: 11px;
          font-weight: 700;
          color: var(--muted);
          letter-spacing: 0.18em;
          text-transform: uppercase;
          margin-bottom: 10px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
        .tqb-eyebrow::before {
          content: "";
          width: 28px; height: 2px;
          background: var(--coral);
        }
        .tqb-h2 {
          font-family: "Heebo", sans-serif;
          font-weight: 900;
          font-size: 40px;
          line-height: 1.08;
          letter-spacing: -0.02em;
          margin: 0;
          color: var(--ink);
        }
        @media (max-width: 700px) {
          .tqb-h2 { font-size: 28px; }
          .tqb-head { grid-template-columns: 1fr; gap: 14px; }
        }
        .tqb-h2 .hl-block { font-size: 0.95em; }
        .tqb-lede {
          font-size: 15px;
          line-height: 1.55;
          color: var(--ink-2);
          margin: 0;
          padding-bottom: 4px;
        }
        .tqb-lede em {
          font-style: normal;
          font-weight: 700;
          color: var(--ink);
          background: var(--yellow-soft);
          padding: 0 4px;
          border-radius: 3px;
        }
        .tqb-rows { display: flex; flex-direction: column; }
        .tqb-row {
          display: grid;
          grid-template-columns: 80px 1fr 240px;
          gap: 24px;
          align-items: center;
          padding: 18px 0;
          border-bottom: 1.5px dashed rgba(14,14,16,.18);
          position: relative;
          transition: background .2s ease, padding .2s ease;
        }
        /* Tablet: keep 3 columns, smaller */
        @media (max-width: 980px) and (min-width: 641px) {
          .tqb-row {
            grid-template-columns: 70px 1fr 180px;
            gap: 16px;
          }
          .tqb-visual { height: 90px; padding: 10px; }
          .v01 { font-size: 11px; gap: 6px; }
          .v01 .blob-bad, .v01 .blob-good { padding: 8px 6px; }
          .v01 .arrow-mid { font-size: 18px; }
          .v02 .ppl { width: 22px; height: 40px; }
          .v02 .ppl.owner { height: 62px; }
          .v03 .ai-box { font-size: 11px; padding: 5px 14px; margin-top: 10px; }
        }
        /* Mobile: visual stacks below number+text */
        @media (max-width: 640px) {
          .tqb-row {
            grid-template-columns: 56px 1fr;
            grid-template-areas:
              "num text"
              "visual visual";
            row-gap: 12px;
            column-gap: 12px;
            align-items: center;
          }
          .tqb-num { grid-area: num; font-size: 44px; }
          .tqb-num .pip { width: 14px; height: 14px; top: -4px; right: -6px; }
          .tqb-text { grid-area: text; }
          .tqb-visual {
            grid-area: visual;
            display: flex;
            height: 84px;
            padding: 10px 14px;
          }
          .v01 { font-size: 12px; gap: 10px; }
          .v01 .blob-bad, .v01 .blob-good { padding: 8px 6px; }
          .v01 .arrow-mid { font-size: 20px; }
          .v02 .ppl { width: 24px; height: 42px; }
          .v02 .ppl.owner { height: 64px; }
          .v03 .ai-box { font-size: 11px; padding: 5px 14px; margin-top: 8px; }
        }
        .tqb-row:last-child { border-bottom: none; }
        .tqb-row:hover {
          background: var(--cream);
          padding-inline: 18px;
          margin-inline: -18px;
          border-radius: 16px;
        }
        .tqb-num {
          font-family: "Fredoka", sans-serif;
          font-weight: 700;
          font-size: 60px;
          line-height: 0.9;
          letter-spacing: -0.04em;
          color: var(--ink);
          position: relative;
        }
        .tqb-num .pip {
          position: absolute;
          top: -6px; right: -10px;
          width: 18px; height: 18px;
          border-radius: 50%;
          border: 2px solid var(--ink);
        }
        .tqb-row[data-accent="coral"]  .tqb-num .pip { background: var(--coral); }
        .tqb-row[data-accent="lilac"]  .tqb-num .pip { background: var(--lilac); }
        .tqb-row[data-accent="yellow"] .tqb-num .pip { background: var(--yellow); }
        .tqb-text { min-width: 0; }
        .tqb-q {
          font-family: "Heebo", sans-serif;
          font-weight: 800;
          font-size: 20px;
          line-height: 1.28;
          letter-spacing: -0.015em;
          color: var(--ink);
          margin: 0 0 6px;
        }
        @media (max-width: 700px) { .tqb-q { font-size: 17px; } }
        .tqb-a {
          font-size: 14px;
          line-height: 1.55;
          color: var(--ink-2);
          margin: 0;
          font-weight: 400;
          max-width: 640px;
        }
        .tqb-a strong { font-weight: 700; color: var(--ink); }
        .tqb-visual {
          width: 100%;
          height: 100px;
          border: 2px solid var(--ink);
          border-radius: 16px;
          background: var(--cream);
          box-shadow: 4px 4px 0 var(--ink);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 14px;
          box-sizing: border-box;
          overflow: hidden;
        }
        .v01 {
          display: grid;
          grid-template-columns: 1fr auto 1fr;
          gap: 12px;
          width: 100%;
          align-items: center;
          font-family: "Space Grotesk", sans-serif;
          font-weight: 600;
          font-size: 12px;
        }
        .v01 .blob-bad {
          background: rgba(255,106,77,.18);
          border: 1.5px dashed var(--coral);
          padding: 12px 8px;
          border-radius: 10px;
          color: var(--coral);
          text-align: center;
          line-height: 1.3;
        }
        .v01 .arrow-mid { font-size: 26px; color: var(--ink); }
        .v01 .blob-good {
          background: var(--yellow);
          border: 1.5px solid var(--ink);
          padding: 12px 8px;
          border-radius: 10px;
          color: var(--ink);
          text-align: center;
          line-height: 1.3;
        }
        .v02 {
          display: flex;
          align-items: end;
          gap: 8px;
          width: 100%;
          justify-content: center;
        }
        .v02 .ppl {
          width: 32px;
          background: var(--paper-2);
          border: 1.5px solid var(--ink);
          border-radius: 8px 8px 4px 4px;
          height: 56px;
          position: relative;
        }
        .v02 .ppl.owner {
          background: var(--lilac);
          height: 86px;
        }
        .v02 .ppl.owner::before {
          content: "★";
          position: absolute;
          top: -18px; left: 50%;
          transform: translateX(-50%);
          font-size: 16px;
          color: var(--ink);
        }
        .v02 .ppl::after {
          content: "";
          position: absolute;
          top: 8px; left: 50%;
          transform: translateX(-50%);
          width: 16px; height: 16px;
          border-radius: 50%;
          background: var(--ink);
        }
        .v03 {
          display: flex;
          flex-direction: column;
          gap: 6px;
          width: 100%;
          align-items: stretch;
          justify-content: center;
        }
        .v03 .process-bar {
          height: 14px;
          background: linear-gradient(90deg,
            rgba(255,106,77,.5) 0%,
            rgba(255,106,77,.5) 30%,
            var(--ink-2) 30%,
            var(--ink-2) 60%,
            rgba(181,166,255,.6) 60%);
          border: 1.5px solid var(--ink);
          border-radius: 8px;
          position: relative;
        }
        .v03 .process-bar::before {
          content: "תהליך שבור";
          position: absolute;
          top: 100%; right: 0;
          font-family: "Space Grotesk", sans-serif;
          font-size: 10px;
          color: var(--muted);
          margin-top: 4px;
          letter-spacing: 0.06em;
        }
        .v03 .ai-box {
          background: var(--ink);
          color: var(--yellow);
          padding: 8px 22px;
          border-radius: 10px;
          font-family: "Space Grotesk", sans-serif;
          font-weight: 700;
          font-size: 13px;
          letter-spacing: 0.08em;
          text-align: center;
          margin-top: 18px;
          box-shadow: 3px 3px 0 var(--yellow);
          align-self: flex-end;
        }
        .v03 .ai-box::before {
          content: "↓ מאיץ ↓";
          display: block;
          font-size: 10px;
          color: rgba(255,205,46,.6);
          letter-spacing: 0.16em;
          margin-bottom: 2px;
        }
      `}</style>

      <div className="wrap">
        <div className="tqb-head">
          <div>
            <div className="tqb-eyebrow">לפני שכותבים לי · FILTER</div>
            <h2 className="tqb-h2">
              3 שאלות שאני שואל<br />
              בכל <span className="hl-block tilt-l">שיחה ראשונה</span>.
            </h2>
          </div>
          <p className="tqb-lede">
            לפעמים אני אומר <em>״אני לא המתאים.״</em> זה לא רע. זה טוב לשני הצדדים.
            <br />
            לפני שלוחצים ״וואטסאפ״, שאלו את עצמכם:
          </p>
        </div>

        <div className="tqb-rows">
          <div className="tqb-row" data-accent="coral">
            <div className="tqb-num">01<span className="pip"></span></div>
            <div className="tqb-text">
              <h3 className="tqb-q">האם יש לך הגדרה ברורה של מה הצרכים? מה לא עובד?</h3>
              <p className="tqb-a">
                אם התשובה היא <strong>״הכל״</strong> או <strong>״אנחנו עוד לא יודעים״</strong>, זה אומר שצריך לעשות שיקוף מצב קיים לפני שמתחילים בעבודה האמיתית.
              </p>
            </div>
            <div className="tqb-visual">
              <div className="v01">
                <div className="blob-bad">״הכל שבור״</div>
                <div className="arrow-mid">←</div>
                <div className="blob-good">3 כאבים מוגדרים</div>
              </div>
            </div>
          </div>

          <div className="tqb-row" data-accent="lilac">
            <div className="tqb-num">02<span className="pip"></span></div>
            <div className="tqb-text">
              <h3 className="tqb-q">מי מקבל החלטות אצלכם?</h3>
              <p className="tqb-a">
                פרויקט בלי <strong>owner ברור</strong> = פרויקט שנגרר חודשים.
              </p>
            </div>
            <div className="tqb-visual">
              <div className="v02">
                <div className="ppl"></div>
                <div className="ppl"></div>
                <div className="ppl owner"></div>
                <div className="ppl"></div>
                <div className="ppl"></div>
              </div>
            </div>
          </div>

          <div className="tqb-row" data-accent="yellow">
            <div className="tqb-num">03<span className="pip"></span></div>
            <div className="tqb-text">
              <h3 className="tqb-q">האם אתם מצפים ש-AI יסדר את הכאוס?</h3>
              <p className="tqb-a">
                <strong>AI לא פותר תהליך שבור, הוא מאיץ אותו.</strong><br />אני בונה תהליך נכון, ואז AI נכנס.
              </p>
            </div>
            <div className="tqb-visual">
              <div className="v03">
                <div className="ai-box">AI · ACCELERATOR</div>
                <div className="process-bar"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
